"use strict";
exports.__esModule = true;
exports.RemoteComponent = void 0;
var createRemoteComponent_1 = require("../createRemoteComponent");
var createRequires_1 = require("../createRequires");
var getDependencies_1 = require("../getDependencies");
var requires = createRequires_1.createRequires(getDependencies_1.getDependencies);
exports.RemoteComponent = createRemoteComponent_1.createRemoteComponent({ requires: requires });
//# sourceMappingURL=RemoteComponent.js.map